import * as React from 'react';
import { Link } from '@fluentui/react';

declare const healConfig: any;

interface Props {
  referenceId?: string;
  medicare?: boolean;
}

export const InsuranceTransactionLinks = ({ referenceId, medicare }: Props) => {
  if (!referenceId) {
    return null;
  }

  const request = `https://insuranceservice.${healConfig.env}-uswest2.heal.com/v1/txlog/eligible_cost_estimate_request?id=${referenceId}`;
  const response = `https://insuranceservice.${healConfig.env}-uswest2.heal.com/v1/txlog/${
    medicare ? 'eligible_medicare_coverage_response' : 'eligible_cost_estimate'
  }?id=${referenceId}`;

  return (
    <>
      <Link href={request} target="_blank">
        Request
      </Link>
      {' | '}
      <Link href={response} target="_blank">
        Response
      </Link>
    </>
  );
};
